import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, type, keywords, image }) {
    const name = 'PocketPet';
    //get url of current page
    var url = window.location.href;
    // delect last / from url if it exists
    if (url[url.length - 1] === '/') {
        url = url.slice(0, -1);
    }
    // remove www. from url if it exists
    if (url.includes('www.')) {
        url = url.replace('www.', '');
    }

    //replace with regex: https?://localhost:\d*/ with https://pocketpet.de/
    if (url.includes('localhost')){
        url = url.replace(/https?:\/\/localhost:\d*/g, 'https://pocketpet.de');
    }
    
    keywords = ['Tierheim', 'Vermittlung', 'Online Tierheim', 'Rettung'].concat(keywords);

    return (
        <Helmet>
            { /* Standard metadata tags */}
            <title>{title}</title>
            <meta name='description' content={description} data-rh="true"/>
            <meta name="keywords" content={keywords.join(', ')} data-rh="true"/>
            <link rel='canonical' href={url} data-rh="true"/>
            <link rel='home' href='pocketpet.de' data-rh="true"/>
            { /* End standard metadata tags */}
            { /* Facebook tags */}
            <meta property="og:type" content={type} data-rh="true"/>
            <meta property="og:title" content={title} data-rh="true"/>
            <meta property="og:description" content={description} data-rh="true"/>
            <meta property="og:url" content={url} data-rh="true"/>
            <meta property="og:image" content={image || 'https://pocketpet.de/apple-touch-icon-180x180.png'} data-rh="true"/>
            { /* End Facebook tags */}
            { /* Twitter tags */}
            <meta name="twitter:creator" content={name} data-rh="true"/>
            <meta name="twitter:card" content={type} data-rh="true"/>
            <meta name="twitter:title" content={title} data-rh="true"/>
            <meta name="twitter:description" content={description} data-rh="true"/>
            <meta name="twitter:image" content={image || "https://pocketpet.de/apple-touch-icon-180x180.png"} data-rh="true"/>
            { /* End Twitter tags */}
        </Helmet>
    )
}


//Example:          <SEO title='Learning React Helmet!' description='Beginner friendly page for learning React Helmet.' name='Company name.' type='article' image='https://example.com/image.png' />
